import * as React from 'react'

import Translation from '../../containers/Translation';
import { T_LOADING } from '../../api/translations';
import useTranslation from '../../hooks/useTranslation';

import('./StatsOverallStyles.scss')   



export const StatsOverallPresentation = (props:any) => {
    const servicePointsWonText = useTranslation('StatisticsOverall_servicePointsWon');
    const breakPointsWonText = useTranslation('StatisticsOverall_breakPointsWon');
    const totalPointsWonText = useTranslation('StatisticsOverall_totalPointsWon');
    const last10PointsText = useTranslation('StatisticsOverall_last10Points');
    const acesText = useTranslation('StatisticsOverall_aces');
    const doubleFaultsText = useTranslation('StatisticsOverall_doubleFaults');

    // fallback - if data is missing, render a placeholder
    if (!props.servicePoints || !props.breakPoints || !props.points || !props.aces || !props.doubleFaults) {
        return (
            <div className="overallStatistics sr-grid sr-align-center">
                <div className="sr-cell sr-stats-loading"><Translation tag={T_LOADING} /></div>
            </div>
        )
    }

    // render found data
    return (
        <div className="overallStatistics">
            {statisticRowTemplate(servicePointsWonText, props.servicePoints.home, props.servicePoints.away, props.servicePoints.ofHome, props.servicePoints.ofAway)}
            {statisticRowTemplate(breakPointsWonText, props.breakPoints.home, props.breakPoints.away, props.breakPoints.ofHome, props.breakPoints.ofAway)}
            {statisticRowTemplate(totalPointsWonText, props.points.home, props.points.away)}
            {statisticRowTemplate(last10PointsText, props.last10Points.home, props.last10Points.away)}
            {statisticRowTemplate(acesText, props.aces.home, props.aces.away)}
            {statisticRowTemplate(doubleFaultsText, props.doubleFaults.home, props.doubleFaults.away)}
        </div>
    )
}

const statisticRowTemplate = (statisticName:string, valueHome:number, valueAway:number, totalHome:number = null,
                              totalAway:number = null) => {
    let header:any
    let barHome:any
    let barAway:any

    if (totalHome !== null || totalAway !== null) {
        header = statisticHeaderTemplate(statisticName, `${valueHome}/${totalHome}`, `${valueAway}/${totalAway}`)
        barHome = statisticBarTemplate('home', calcPercentualPortionOfValueAToB(calcPercentage(valueHome, totalHome),
            calcPercentage(valueAway, totalAway)))
        barAway = statisticBarTemplate('away', calcPercentualPortionOfValueAToB(calcPercentage(valueAway, totalAway),
            calcPercentage(valueHome, totalHome)))
    } else {
        header = statisticHeaderTemplate(statisticName, `${valueHome}`, `${valueAway}`)
        barHome = statisticBarTemplate('home', calcPercentualPortionOfValueAToB(valueHome, valueAway))
        barAway = statisticBarTemplate('away', calcPercentualPortionOfValueAToB(valueAway, valueHome))
    }

    return (
        <div className={`statistic row`}>
            { header }
            <div className={`statistic-bar-wrapper`}>
                {barHome}
                {barAway}
            </div>
        </div>
    )
}


const statisticHeaderTemplate = (statisticName:string, valueHome:string, valueAway:string) => {
    return (
        <div className={`statistic-header-wrapper`}>
            <div className={`content left`}>
                <span>{valueHome}</span>
            </div>
            <div className={`content center`}>
                <span>{statisticName}</span>
            </div>
            <div className={`content right`}>
                <span>{valueAway}</span>
            </div>
        </div>
    )
}

const statisticBarTemplate = (homeOrAway:string, value:number) => {
    return (
        <div
            className={`bar ${homeOrAway}`}
            style={{width: `${value}%`}}>

            <div className={`partial-bar top`}></div>
            <div className={`partial-bar bottom`}></div>
        </div>
    )
}

const calcPercentage = (valueA:number, valueB:number) => {
    // in case of 0/0 we have to set the result to 0 to prevent a 'NaN'
    let value = (valueA != 0 && valueB != 0) ? valueA / valueB * 100 : 0
    return value
}

// compare two values and return the equaliness. (e.g. 20/20 would be 50% and 20/5 would be 80% (or 5/20 -> 20%))
const calcPercentualPortionOfValueAToB = (valueA:number, valueB:number) => {

    // in case of 0 and 0 set 50% by default
    let value = (valueA==0 && valueB==0) ? 50 : valueA / ( valueA + valueB ) * 100;
    return value;
}

export default StatsOverallPresentation